export default [20, 30, 40];
